import {useFormik} from 'formik';
import {useNavigate} from 'react-router-dom';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import usePostStoreOrder from '../../../services/hookService/postStoreOrder/usePostStoreOrder';
import DeliveryTypeField from './components/DeliveryTypeField';
import RecipientInfoField from './components/RecipientInfoField';
import {IInfoFormValues, infoInitialValues} from './infoFormValues';

import DatePickerBottomSheet from '../../../components/DatePickerBottomSheet';
import {jalaliToGregorian} from '../../../utilities/helper/GetPersianDateTime';
import {infoValidationSchema} from './components/DeliverySchema';
import classNames from 'classnames';

const CompleteInfo = () => {
  const navigate = useNavigate();

  const handleSuccess = (data: ICreateOrderResponse) => {
    navigate(`/check-order/${data.guid}`);
  };

  const {mutate, isLoading} = usePostStoreOrder(handleSuccess);

  const form = useFormik({
    initialValues: infoInitialValues,
    validationSchema: infoValidationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values: IInfoFormValues) => {
      const payload = convertToNewOrderPayload(values);
      mutate(payload);
    },
  });

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">تکمیل اطلاعات</span>
          </div>
        )}
      />

      <div className="flex flex-col w-full h-full p-3 overflow-y-auto">
        <form onSubmit={form.handleSubmit} className="space-y-5">
          <DatePickerBottomSheet
            value={form.values.deliveryDate}
            title="زمان تامین کالاها"
            titleClassName="text-sm font-medium text-gray-800"
            placeholder="زمان تامین را مشخص کنید"
            onChange={val => form.setFieldValue('deliveryDate', val, true)}
            required
            disablePastDates
          />
          {form.touched.deliveryDate && form.errors.deliveryDate && (
            <div className="text-sm text-red-500">
              {form.errors.deliveryDate}
            </div>
          )}

          <DeliveryTypeField form={form} />

          {form.touched.deliveryType && form.errors.deliveryType && (
            <div className="text-sm text-red-500">
              {form.errors.deliveryType}
            </div>
          )}

          {form.values.deliveryType === 'seller' && (
            <RecipientInfoField form={form} />
          )}
        </form>
      </div>

      <div className="w-full h-20 flex p-3 bg-white shadow-[0px_-1px_6px_0px_rgba(0,_0,_0,_0.1)]">
        <button
          type="button"
          className="w-full text-white rounded-lg bg-farm-shop-500 disabled:bg-gray-300 disabled:text-gray-700"
          onClick={() => form.handleSubmit()}
          disabled={isLoading}
        >
          تایید و ادامه
        </button>
      </div>
    </div>
  );
};

export default CompleteInfo;

export const convertToNewOrderPayload = (
  values: IInfoFormValues,
): OrderPayload => {
  // 'in-person' only needs supply_date and a boolean
  const GregorianDeliveryData = jalaliToGregorian(values.deliveryDate);
  if (values.deliveryType === 'in-person') {
    return {
      supply_date: GregorianDeliveryData,
      person_delivery: true,
    };
  }

  // Otherwise send full payload
  return {
    profile_address: {
      name: values.recipientName,
      delivery_address: values.address,
      building_number: String(values.plateNumber ?? ''),
      postal_code: String(values.postalCode ?? ''),
      city: Number(values.city ?? ''),
    },
    supply_date: GregorianDeliveryData,
  } as OrderPayload;
};
